import { render, staticRenderFns } from "./imagen.vue?vue&type=template&id=3c425783&"
import script from "./imagen.vue?vue&type=script&lang=js&"
export * from "./imagen.vue?vue&type=script&lang=js&"
import style0 from "./imagen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports